var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-container"},[_c('div',{staticClass:"v-row"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('v-spacer'),_c('h4',[_vm._v("Description")]),_c('div',{staticClass:"v-row"},[_c('p',[_vm._v(_vm._s(_vm.description))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }